<script setup>
import { computed, onMounted } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import MentionBox from '../mentions/MentionBox.vue';
import { useI18n } from 'vue-i18n';
import { resolveActionName } from 'dashboard/routes/dashboard/settings/macros/macroHelper';

const props = defineProps({
  searchKey: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['replace']);

const store = useStore();
const { t } = useI18n();

const macros = useMapGetter('macros/getMacros');

const items = computed(() => {
  let filtered = macros.value || [];
  if (props.searchKey) {
    const key = props.searchKey.toLowerCase();
    filtered = filtered.filter(macro => macro.name.toLowerCase().includes(key));
  }

  return filtered.map(macro => {
    return {
      ...macro,
      key: `macro-${macro.id}`,
      description: macro.name,
      label: macro.name, // required for variableKey in MentionBox if we use slot fallback
    };
  });
});

const getActionSummary = macro => {
  if (!macro.actions) return '';
  const names = macro.actions.slice(0, 3).map(action => {
    // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
    return t(`MACROS.ACTIONS.${resolveActionName(action.action_name)}`);
  });
  const summary = names.join(', ');
  return macro.actions.length > 3 ? `${summary}...` : summary;
};

onMounted(() => {
  store.dispatch('macros/get');
});

const handleMentionClick = (item = {}) => {
  emit('replace', item);
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    type="macro"
    @mention-select="handleMentionClick"
  >
    <template #default="{ item, selected }">
      <p
        class="max-w-full min-w-0 mb-0 overflow-hidden text-sm font-medium text-n-slate-11 group-hover:text-n-slate-12 text-ellipsis whitespace-nowrap"
        :class="{ 'text-n-slate-12': selected }"
      >
        {{ item.name }}
      </p>
      <p
        class="max-w-full min-w-0 mb-0 overflow-hidden text-[10px] text-n-slate-10 group-hover:text-n-slate-12 text-ellipsis whitespace-nowrap"
        :class="{ 'text-n-slate-12': selected }"
      >
        {{ getActionSummary(item) }}
      </p>
    </template>
  </MentionBox>
</template>
